export default "__VITE_ASSET__Bj9HO2Jh__"